import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { motion } from "framer-motion";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    fetch("/data/projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data.sort((a, b) => a.id - b.id)))
      .catch((err) => console.error("Failed to load projects:", err));
  }, []);

  if (!projects || projects.length === 0) return (
    <motion.div 
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  exit={{ opacity: 0 }}
  transition={{ duration: 0.3 }}
  className="min-h-screen"
>
    <div className="w-full flex justify-center items-center h-32">
      <ClipLoader color="#fff" size={40} />
    </div>
  </motion.div>
  );

  const renderSkillIcon = (skillName) => {
    let customIcon;
    const iconsPath = "/assets/icons";
    switch (skillName) {
      case "C#":
        customIcon = `${iconsPath}/c-sharp.svg`;
        break;
      case ".NET Framework":
        customIcon = `${iconsPath}/dotnetframework.svg`;
        break;
      case ".NET Core":
        customIcon = `${iconsPath}/dotnetcore.svg`;
        break;
      case "SharePoint":
        customIcon = `${iconsPath}/sharepoint.svg`;
        break;
      case "jQuery":
        customIcon = `${iconsPath}/jQuery.svg`;
        break;
      case "JavaScript":
        customIcon = `${iconsPath}/js.svg`;
        break;
      case "Bootstrap":
        customIcon = `${iconsPath}/bootstrap.svg`;
        break;
      case "AgilePoint NX":
        customIcon = `${iconsPath}/agilepoint.svg`;
        break;
      case "Angular":
        customIcon = `${iconsPath}/angular.svg`;
        break;
      case "Ionic":
        customIcon = `${iconsPath}/ionic.svg`;
        break;
      case "Google API":
        customIcon = `${iconsPath}/google.svg`;
        break;
      case "Azure DevOps":
        customIcon = `${iconsPath}/azure-devops.svg`;
        break;
      case "Nintex Workflow":
          customIcon = `${iconsPath}/nintex.svg`;
          break;
      default:
        customIcon = null;
    }
    return customIcon ? (
      <img src={customIcon} alt={`${skillName} Icon`} className="w-6 h-6" title={skillName}/>
    ) : (
      <span className="text-secondary">{skillName}</span>
    );
  };

  const renderStatusBadge = (status) => {
    const isCompleted = status === "Completed" || status === "Live";
    return (
      <span
      className={`inline-block px-3 py-1 text-xs sm:text-sm font-semibold rounded-full whitespace-nowrap
          ${
          isCompleted
            ? "bg-green-100 text-green-700"
            : "bg-yellow-100 text-yellow-700"
        }`}
      >
        {status} 
      </span>
    );
  };
  

  return (
    <motion.div 
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  exit={{ opacity: 0 }}
  transition={{ duration: 0.3 }}
  className="min-h-screen"
>
    <section className="section bg-gray-100 w-full">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="heading-main text-center mb-8">My Projects</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 items-start">
          {projects.map((project) => (
            <div
              key={project.id}
              className="bg-white shadow-lg rounded-lg overflow-hidden transition duration-300 hover:shadow-xl sm:hover:scale-105"            >
              <div className="p-4 sm:p-6">
                <div className="flex justify-between items-start gap-3 mb-4">
                  <h3 className="heading-sub leading-snug">
                    {project.title}
                  </h3>

                  {renderStatusBadge(project.status)}
                </div>

                {/* <p
                  className="text-gray-600 mb-4"
                  dangerouslySetInnerHTML={{ __html: project.description }}
                /> */}
                <ul className="list-disc pl-5 text-gray-600 mb-4 space-y-1">
                  {(expanded[project.id]
                    ? project.contributions
                    : project.contributions.slice(0, 3)
                  ).map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
                {project.contributions.length > 3 && (
                  <button
                    onClick={() =>
                      setExpanded((prev) => ({
                        ...prev,
                        [project.id]: !prev[project.id],
                      }))
                    }
                    className="text-sm text-blue-500 hover:underline mb-3"
                  >
                    {expanded[project.id] ? "Show less" : "Show more"}
                  </button>
                )}
                <div className="text-gray-500 text-sm mb-4 space-y-1 line-clamp-6">
                  {/* {project.startDate && (
                    <p>
                      <strong>Start Date:</strong> {project.startDate}
                    </p>
                  )} */}
                </div>
                <div className="flex flex-wrap gap-3 mb-4">
                  {project.skills.map((skill) => (
                    <div key={skill.name} className="flex items-center gap-2">
                      {renderSkillIcon(skill.name)}
                    </div>
                  ))}
                </div>
                {project.link && (
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    View Project
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </motion.div>
  );
};

export default Projects;
